import * as React from 'react';
import { styled } from '@mui/system';
import SharedNoteTitlesGroup from '../NoteTitlesGroup';
import DiamondLine from '../DiamondLine';

const TitleSection = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '30px',
  justifyContent: 'center',
  flexWrap: 'wrap',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '1060px',
  [theme.breakpoints.down('sm')]: {
    gap: '18px',
  },
}));

const NoteCardsTitle = ({ typeofTitle, displayName }) => {
  return (
    <TitleSection>
      <DiamondLine />
      <SharedNoteTitlesGroup typeofTitle={typeofTitle} displayName={displayName} />
    </TitleSection>
  );
};

export default NoteCardsTitle;
